import { BaseResponse } from '../response/BaseResponse';
import { AgmsResponseCode } from '../../enum/AgmsResponseCode';
import { SEARCHABLE_STATISTICS_FIELDS } from '../../constant/constants';
import { matchesSearch } from '../../util/matches-search';

export interface StatsResponse extends BaseResponse {
  Items: Stats[];
}

export interface Stats {
  Client: string;
  Company: string;
  Region: string;
  Group: string;
  Location: string;
  LocationID: string;
  PaymentSource: string | null;
  Device: string;
  DeviceTypeEnum: string;
  PaymentTypeEnum: string;
  CCY: string;
  Bet: number;
  BetTax: number;
  BetAfterTax: number;
  PayOut: number;
  PayoutTax: number;
  PayOutAfterTax: number;
  Win: number;
  WinTax: number;
  WinAfterTax: number;
  ForPayout: number;
  ForPayoutTax: number;
  ForPayoutAfterTax: number;
  GGR: number;
  Balance: number;
  Percentage: number;
  AverageStake: number;
  NumberOfPayInTickets: number;
  NumberOfPayOutTickets: number;
  NumberOfDeletedTickets: number;
  NumberOfTickets: number;
}

export const searchStats = (data: Stats[], searchTerm: string) => {
  const term = searchTerm.toLowerCase();

  return {
    Items: data.filter((item) => SEARCHABLE_STATISTICS_FIELDS.some((field) => matchesSearch(item[field], term, field))),
    Message: '',
    ResponseCode: AgmsResponseCode.OK,
  } as StatsResponse;
};
